import { useLayoutEffect, useRef, useState } from 'react';

const MIN_HEIGHT = 240;

export const useRemainingHeight = (bottomGap: number) => {
  const ref = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(MIN_HEIGHT);

  useLayoutEffect(() => {
    const measure = () => {
      if (!ref.current) return;
      const top = ref.current.getBoundingClientRect().top;
      setHeight(Math.max(MIN_HEIGHT, window.innerHeight - top - bottomGap));
    };
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [bottomGap]);

  return { ref, height };
};
